module.exports = {"620522100":"兴国镇","620522101":"莲花镇","620522102":"西川镇","620522103":"陇城镇","620522104":"郭嘉镇","620522105":"五营镇","620522106":"叶堡镇","620522107":"魏店镇","620522108":"安伏镇","620522109":"千户镇","620522110":"王尹镇","620522111":"兴丰镇","620522200":"刘坪乡","620522202":"中山乡","620522206":"王铺乡","620522208":"王窑乡","620522209":"云山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620522.json
// module id = 2698
// module chunks = 0